<template>
    <b-table-simple borderless>
        <b-tbody>
            <b-tr>
                <b-th>Name:</b-th>
                <b-td>
                    <span>
                        <router-link
                            v-if="USE_PATIENT_MODULE_VUE"
                            :to="{
                                name: 'patient_profile',
                                params: {
                                    id: patient.encoded_id || patient.encodedId
                                }
                            }"
                            >{{ patient.name }}
                        </router-link>
                        <a
                            v-else
                            :href="`${CI_APPS}patient/patient/view/${patient.encoded_id}`"
                            >{{ patient.name }}
                        </a>
                    </span>
                    <span v-if="patient.primary_owner.length > 0">
                        (<client-name
                            showPopover
                            :title="getFullName(patient.primary_owner[0])"
                            :client="patient.primary_owner[0]"
                            :text="getFullName(patient.primary_owner[0])"
                        >
                            <patient-owner-hover
                                :owner="patient.primary_owner[0]"
                            />
                        </client-name>
                        <span v-if="patient.active_owners.length > 1">
                            +
                            <strong
                                class="text-primary cursor-pointer"
                                @click="$emit('load')"
                                >{{ patient.active_owners.length - 1 }}</strong
                            ></span
                        >)
                    </span>
                </b-td>
            </b-tr>
            <b-tr>
                <b-th>Status:</b-th>
                <b-td>
                    {{ getStatus(patient) }}
                </b-td>
            </b-tr>
            <b-tr>
                <b-th>Breed:</b-th>
                <b-td>
                    {{ getEntityBreed(patient) }}
                </b-td>
            </b-tr>
            <b-tr>
                <b-th>Color:</b-th>
                <b-td>
                    {{ patient.color }}
                </b-td>
            </b-tr>
            <b-tr>
                <b-th>Sex:</b-th>
                <b-td>
                    {{ getSex() }}
                </b-td>
            </b-tr>
            <b-tr>
                <b-th>Age:</b-th>
                <b-td>
                    {{ patient.age }}
                </b-td>
            </b-tr>
            <b-tr>
                <b-th class="w-25">Birthdate:</b-th>
                <b-td>
                    <span v-if="patient.birthdate">
                        {{ _carbonDateDisplay(patient.birthdate) }}
                    </span>
                    <span v-else-if="patient.est_birthdate">
                        {{ _carbonDateDisplay(patient.est_birthdate) }}
                        (est.)
                    </span>
                </b-td>
            </b-tr>
            <b-tr>
                <b-th>Chip:</b-th>
                <b-td>
                    {{ patient.chip }}
                </b-td>
            </b-tr>
            <b-tr>
                <b-th>Weight:</b-th>
                <b-td> {{ patient.weight }} {{ getWeightDate(patient) }} </b-td>
            </b-tr>
            <b-tr>
                <b-th class="text-nowrap">Next Visit:</b-th>
                <b-td>
                    <router-link
                        v-if="patient.next_visit"
                        :to="{
                            name: 'appointment',
                            params: {
                                view: 'resourceTimeGridDay',
                                start: getDateInSeconds(patient.next_visit)
                            }
                        }"
                        >{{ _carbonDateTimeDisplay(patient.next_visit) }}
                    </router-link>
                    <span v-else>Not scheduled</span>
                </b-td>
            </b-tr>
            <b-tr>
                <b-th class="text-nowrap">Primary Provider:</b-th>
                <b-td>
                    <span
                        v-if="
                            patient.primary_provider &&
                            patient.primary_provider.id
                        "
                    >
                        {{ patient.primary_provider.label }}
                        {{ getProviderStatus(patient.primary_provider) }}
                    </span>
                    <span v-else>
                        No primary provider
                    </span>
                </b-td>
            </b-tr>
        </b-tbody>
    </b-table-simple>
</template>
<script>
import PatientOwnerHover from "../patient-owner-hover.vue";
import ClientName from "@/components/commons/client-name";

export default {
    components: {
        PatientOwnerHover,
        ClientName
    },
    props: {
        patient: {
            type: Object
        }
    },
    data() {
        return {
            CI_APPS: process.env.CI_APPS
        };
    },
    methods: {
        getEntityBreed(patient) {
            var breeds = [];

            if (
                patient.patient_breeds &&
                _.keys(patient.patient_breeds).length > 0
            ) {
                $.each(patient.patient_breeds, function (i, v) {
                    breeds.push(v.name + " (" + v.species_name + ")");
                });
            }

            return breeds.join(", ");
        },
        getStatus(patient) {
            let status = "Active";
            if (patient.isactive === false) {
                status = "Deleted";
            } else if (patient.status === 2) {
                status = "Inactive";
            } else if (patient.status === 3) {
                status = "Deceased";
            }

            if (patient.status > 1) {
                status +=
                    " (" + this._carbonDateDisplay(patient.status_date) + ")";
            }

            return status;
        },
        getFullName(details) {
            return details.lastname + ", " + details.firstname;
        },
        getSex() {
            if (this.patient.patient_sex) {
                return this.patient.patient_sex.value;
            }
            return "";
        },
        getDateInSeconds(date) {
            return date ? this._fromDateCarbon(date).toSeconds() : null;
        },
        getWeightDate(patient) {
            let weightDate = "";
            if (patient.weightData && patient.weightData.date) {
                weightDate =
                    " (" +
                    this._carbonDateDisplay(patient.weightData.date) +
                    ")";
            }
            return weightDate;
        },
        getProviderStatus(provider) {
            if (!provider || !provider.id) {
                return "";
            }
            return provider.business_actor_isactive ? "" : "(deactivated)";
        }
    }
};
</script>
<style type="text/css" lang="scss" scoped>
table tbody tr td:first-child {
    font-weight: bold;
}

.table th,
.table td {
    padding: 0px;
    line-height: 30px;
}
</style>
